import { EntityProject } from "../../entity/EntityProject";

export class DtoProjectsPostRes extends EntityProject {}
